import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import MobileExpandablePanel from '../ExpandableCard/MobileExpandablePanel';
import { isIPad13, isMobile, isTablet } from 'react-device-detect';
import { isOkq8 } from '../../../services/partners/partnersService';
import MobileVerticalBreak from './MobileExpandedCardVerticalGap/MobileVerticalBreak';

interface Props {
    insuranceData: any;
    allCoveragesList: any;
    chosenInsuranceName: string;
    chosenInsuranceIndex?: any;
    additionalContentMap?: any[];
}

const ExpandedCards: React.FC<Props> = ({
    children,
    insuranceData,
    allCoveragesList,
    chosenInsuranceName,
    chosenInsuranceIndex,
    additionalContentMap
}) => {
    const [openCoverageIndex, setOpenCoverageIndex] = useState(-1);

    useEffect(() => {
        setOpenCoverageIndex(-1);
    }, [chosenInsuranceName]);
    return (
        <>
            <div
                className={classNames(
                    'row align-center justify-content-center',
                    { 'margin-bottom-26': !(isMobile || isTablet || isIPad13) },
                    {
                        'padding-left-right-26':
                            !(isMobile || isTablet || isIPad13) && isOkq8()
                    }
                )}>
                {children}
            </div>
            {(isMobile || isTablet || isIPad13) && isOkq8() && (
                <MobileVerticalBreak
                    chosenInsuranceName={chosenInsuranceName}
                />
            )}
            {(isMobile || isTablet || isIPad13) && (
                <div
                    className={classNames('row', {
                        'padding-left-right-26':
                            !(isMobile || isTablet || isIPad13) && isOkq8()
                    })}>
                    <MobileExpandablePanel
                        allCoveragesList={allCoveragesList}
                        insuranceData={insuranceData}
                        openCoverageIndex={openCoverageIndex}
                        setOpenCoverageIndex={setOpenCoverageIndex}
                        additionalContentMap={additionalContentMap}
                        chosenInsuranceIndex={chosenInsuranceIndex}
                    />
                </div>
            )}
        </>
    );
};

export default ExpandedCards;
